<template>
  <div>
    <p>
      {{
        ft(featureName, 'reportingChannels.phoneCall.responseDescription', $t, {
          organizationTitle: organizationFullName,
          email
        })
      }}
    </p>
    <a :href="`tel://${phoneNumber}`">
      <h4>
        {{ phoneNumberString }}
      </h4>
    </a>
    <p v-if="false" class="my-4">
      {{
        ft(featureName, 'reportingChannels.phoneCall.responseWarning', $t, {
          organizationTitle: organizationFullName,
          email
        })
      }}
    </p>
    <div class="alert alert-info my-8">
      <h5 class="text-info">
        {{
          ft(
            featureName,
            'reportingChannels.phoneCall.responseInstructionsHeader',
            $t
          )
        }}
      </h5>
      <ul>
        <li>
          {{
            ft(
              featureName,
              'reportingChannels.phoneCall.responseInstructions1',
              $t
            )
          }}
        </li>
        <li>
          {{
            ft(
              featureName,
              'reportingChannels.phoneCall.responseInstructions2',
              $t
            )
          }}
        </li>
        <li>
          {{
            ft(
              featureName,
              'reportingChannels.phoneCall.responseInstructions3',
              $t
            )
          }}
        </li>
        <li>
          {{
            ft(
              featureName,
              'reportingChannels.phoneCall.responseInstructions4',
              $t
            )
          }}
        </li>
      </ul>
    </div>
    <followup-case-details
      :case-name="caseName"
      :password="password"
      :followup-url="followupUrl"
      :feature-name="featureName"
    />
    <b-row class="my-4">
      <b-alert :show="true" variant="default" class="px-0">
        <div class="d-flex align-items-center">
          <i class="bi bi-info-circle-fill fs-3 text-info mx-3"></i>
          <span class="text-info">
            {{ ft(featureName, 'received.bottomWarning', $t) }}
          </span>
        </div>
      </b-alert>
    </b-row>
  </div>
</template>
<script>
import LocalizableComponent from './LocalizableComponent.vue'
import FollowupCaseDetails from './FollowupCaseDetails.vue'

export default {
  name: 'PhoneCallResponse',
  components: { FollowupCaseDetails },
  extends: LocalizableComponent,
  props: {
    organizationName: {
      type: String,
      required: true
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    caseName: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    },
    email: {
      type: String,
      default: null,
      required: false
    },
    locale: {
      type: String,
      default: null,
      required: false
    },
    followupUrl: {
      type: String,
      required: true
    },
    featureName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      phoneNumber: '+46406207085',
      phoneNumberString: '+46 40 620 70 85'
    }
  }
}
</script>
<style scoped>
.instructions-box {
  background: rgb(240, 240, 255);
  max-width: 600px;
  border-radius: 5px;
  padding: 2px;
  padding-right: 10px;
}
</style>
